import space from './space';
import weather from './weather';
import simpleMachines from './simple-machines';
import humanBody from './human-body';
import mammals from './mammals';
import earth from './earth';
import skyscrapers from './skyscrapers';
import homes from './homes';
import coralReef from './coral-reef';
import statesOfMatter from './states-of-matter';

export default {
  'states-of-matter': statesOfMatter,
  weather,
  'simple-machines': simpleMachines,
  'human-body': humanBody,
  space,
  mammals,
  earth,
  skyscrapers,
  homes,
  'coral-reef': coralReef,
};
